import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import withRouter from 'utils/withRouter';

import Spinner from 'components/Spinner';
import { ERROR, SUCCESS } from 'lookup/ResponseCodes';
import Container from 'react-bootstrap/Container';
import * as ART from 'services/ApiRequestTrackerService';
import { getErrorMessage } from 'services/UtilityService';
import { resetDsgEventRequest } from 'views/Cat/DynamicSwitchGroupDetails/DynamicSwitchGroupDetails.actions';
import DynamicSwitchGroupBox from './DynamicSwitchGroupBox';
import DynamicSwitchOptions from './DynamicSwitchOptions';
import { IN_PROGRESS } from 'lookup/ResponseCodes';
import FloatingButton from 'components/FloatingButton';
import { showNotification } from 'services/NotificationService';

const DynamicSwitchBox = (props) => {
  const dispatch = useDispatch();
  const history = props.history;
  const { dynamicSwitchGroup } = props.match.params;  
  // Get state from Redux using useSelector
  const fetchDsgRequestStatus = useSelector((state) => 
    state.dynamicSwitchGroupDetails ? state.dynamicSwitchGroupDetails.fetchDsgRequestStatus : null
  );
  const updateDsgRequestStatus = useSelector((state) => 
    state.dynamicSwitchGroupDetails ? state.dynamicSwitchGroupDetails.updateDsgRequestStatus : null
  );
  const showDelta = useSelector((state) => state.dynamicSwitchGroupDetails?.showDelta);
  const allowEditing = useSelector((state) => {
    return state.codexVersion?.isWorkingVersionEditable && 
           state.dynamicSwitchGroupDetails?.allowEditing && 
           !state.dynamicSwitchGroupDetails?.showDelta
      ? state.dynamicSwitchGroupDetails.allowEditing 
      : false;
  });
  
  const [apiRequestTracker, setApiRequestTracker] = useState(ART.init(true));
  const prevFetchStatusRef = useRef(fetchDsgRequestStatus);
  const prevUpdateStatusRef = useRef(updateDsgRequestStatus);

  useEffect(() => {
    if (fetchDsgRequestStatus === ERROR && prevFetchStatusRef.current !== ERROR) {
      setApiRequestTracker(ART.failure('ERROR_FETCHING_TARGET_GROUP'));
    } else if (fetchDsgRequestStatus === SUCCESS && prevFetchStatusRef.current !== SUCCESS) {
      dispatch(resetDsgEventRequest());
      setApiRequestTracker(ART.success());
    } else if (fetchDsgRequestStatus === IN_PROGRESS && prevFetchStatusRef.current !== IN_PROGRESS) {
      setApiRequestTracker(ART.init(true));
    }
    prevFetchStatusRef.current = fetchDsgRequestStatus;
  }, [fetchDsgRequestStatus, dispatch]);

  useEffect(() => {
    if (updateDsgRequestStatus === SUCCESS && prevUpdateStatusRef.current !== SUCCESS) {
      dispatch(resetDsgEventRequest());
    } else if (updateDsgRequestStatus === ERROR && prevUpdateStatusRef.current !== ERROR) {
      showNotification({
        title: 'Something went wrong!',
        message: getErrorMessage('UNABLE_TO_UPDATE_DYNAMIC_SWITCH_GROUP'),
        position: 'tr',
        type: "error"
      });
    }
    prevUpdateStatusRef.current = updateDsgRequestStatus;
  }, [updateDsgRequestStatus, dispatch]);

  const addDrug = () => {
    history.push(`/cat/dynamic-switch-groups/${dynamicSwitchGroup}/add-new-drug`)
  }

  const searchParams = new URLSearchParams(window.location.search);
  const enableEditing = !searchParams.has('showDisplayCodexBar');

  // on a good day, this will become a HOC
  if (apiRequestTracker.inProgress)
    return <Spinner id='dsg-box-spinner' />
  else if (apiRequestTracker.error)
    return apiRequestTracker.message;
  else {
    return (
      <Container>
        <DynamicSwitchGroupBox />
        <DynamicSwitchOptions showDelta={showDelta} />
        {allowEditing && enableEditing ? <FloatingButton name={"Add new Drug"} onClick={addDrug} /> : null}
      </Container>
    );
  }
}

export default withRouter(DynamicSwitchBox);
